import {Grid, Typography, FormControl, Dialog, DialogContent, DialogContentText, Paper, Divider, InputLabel, OutlinedInput, Select, MenuItem, InputAdornment, Button} from "@material-ui/core";
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import {useEffect, useState, useCallback} from "react";
import {useTranslation} from "react-i18next";
import {makeStyles} from "@material-ui/core/styles";
import _ from "lodash";
import DialogCloseableTitle from "../../Common/DialogCloseableTitle";
import TextField from "@material-ui/core/TextField";
import {useDropzone} from 'react-dropzone';
import DescriptionIcon from '@material-ui/icons/Description';
import {createPayroll, updatePayroll, downloadSavedFiledBlob, getEstimateAmount} from "../../../actions/payRollAdjustmentAction";
import {getUserPreference} from "../../../utilities/common";
import {showAlertSnackbar} from "../../../reducers/uiSlice";
import {useDispatch} from "react-redux";
import {downloadPodQualityExcelBlob} from "../../../actions/podQualityActions";

const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1),
    },
    item: {
        color: 'white'
    },
    excelMargin: {
        margin: theme.spacing(1)
    },
    formControl: {
        marginBottom: theme.spacing(1),
        minWidth: 220,
    },
    dialog: {
        overflow: 'auto',
        maxHeight: '90vh',
        '&::-webkit-scrollbar': {
            width: '7px',
            backgroundColor: 'lightgray',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'gray',
            borderRadius: '4px',
            height: '60px'
        },
    },
    styles: {
        minHeight: '10vh',
        maxHeight: '40vh',
    },
    DropzoneArea: {
        fontSize: 16,
        margin: 0,
        padding: 0
    }
}));

function PaymentAdjustmentDialog(props) {
    const {t} = useTranslation('payrollAdjustment');
    const classes = useStyles();
    const userPref = getUserPreference();
    const dispatch = useDispatch();
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const [reward, setReward] = useState();
    const [driverID, setDriverID] = useState();
    const [reason, setReason] = useState(null);
    const [amount, setAmount] = useState(null);
    const [packageInfo, setPackageInfo] = useState('');
    const [description, setDescription] = useState('');
    const [acceptedFiles, setAcceptedFiles] = useState([]);
    const [deletedFiles, setDeletedFiles] = useState([]);
    const [chargereasonId, setChargereasonId] = useState();
    const [estimateFormula, setEstimateFormula] = useState();
    const [disableEdit, setDisableEdit] = useState();
    const MAX_FILE_COUNT = 4;
    const APPROVED_STATUS = 3;
    const SUBMITED_TO_REVIEW = 2;

    const onDrop = useCallback((file) => {
        if (acceptedFiles.length < MAX_FILE_COUNT && !_.isNil(file)) {
            setAcceptedFiles([...acceptedFiles, {name: file[0].name, file: file}]);
        }
    }, [acceptedFiles]);
    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        onDrop,
        accept: ['image/jpeg', 'image/png', 'application/pdf', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'video/mp4'],
        multiple: true,
        maxFiles: MAX_FILE_COUNT,
    });

    const clearAll = () => {
        setDriverID();
        setAmount();
        setReward();
        setDescription('');
        setPackageInfo();
        setChargereasonId();
        setDeletedFiles([]);
        setDisableEdit();
        setEstimateFormula();
        setAcceptedFiles([]);
    }
    const showDate = (unixTimestamp) => {
        if (!_.isNil(unixTimestamp)) {
            const date = new Date(unixTimestamp * 1000);
            if (!_.isNil(props?.timezone)) {
                return date.toLocaleString('en-US', {timeZone: props?.timezone});
            } else {
                return date.toLocaleString();
            }
        }
        return "N/A";
    }
    const downloadFile = async (fileName) => {
        props.handledataloading(true);
        try {
            const params = {
                adjustment_id: props?.payrollDetail?.id,
                file_name: fileName,
            };
            await downloadSavedFiledBlob(params);
        } catch (error) {
            if (error?.status === 200) {
                dispatch(
                    showAlertSnackbar({
                        message: "error to download this file",
                        type: "warning",
                    })
                );
            } else {
                dispatch(
                    showAlertSnackbar({
                        message: t("fetch_error"),
                        type: "error",
                    })
                );
            }
        } finally {
            props.handledataloading(false);
        }
    };
    const savePayRollTicket = (status, type) => {
        props.handledataloading(true)
        const formData = new FormData();
        formData.append('driver_id', driverID);
        formData.append('status', status);
        formData.append('deduction_subsidy', reward);
        formData.append('charge_reason', reason);
        formData.append('amount', amount);
        formData.append('tracking_nos', packageInfo);
        formData.append('description', description);
        formData.append('operator', userPref.userId);
        if (!_.isEmpty(acceptedFiles[0]?.file))
            formData.append('file_one', acceptedFiles[0]?.file[0]);
        if (!_.isEmpty(acceptedFiles[1]?.file))
            formData.append('file_two', acceptedFiles[1]?.file[0]);
        if (!_.isEmpty(acceptedFiles[2]?.file))
            formData.append('file_three', acceptedFiles[2]?.file[0]);
        if (!_.isEmpty(acceptedFiles[3]?.file))
            formData.append('file_four', acceptedFiles[3]?.file[0]);
        if (type === 'new') {
            formData.append('warehouse', userPref.userCity);
            dispatch(createPayroll(formData))
                .then((res) => {
                    dispatch(showAlertSnackbar({message: res.data, type: 'success'}))
                    props.handleRefresh()
                    props.handleDialogClose();
                    clearAll();
                })
                .catch((err) => {
                    dispatch(showAlertSnackbar({message: err.message, type: 'error'}))
                })
                .finally(() => {
                    props.handledataloading(false)
                })
        }
        if (type === 'review') {
            formData.append('adjustment_id', props?.payrollDetail?.id);
            formData.append('updated_files', deletedFiles);
            dispatch(updatePayroll(formData))
                .then((res) => {
                    dispatch(showAlertSnackbar({message: res.data, type: 'success'}))
                    props.handleRefresh()
                    props.handleDialogClose();
                    clearAll();
                })
                .catch((err) => {
                    dispatch(showAlertSnackbar({message: err.message, type: 'error'}))
                })
                .finally(() => {
                        props.handledataloading(false)
                    }
                )
        }
    }
    const deleteFiles = (index) => {
        setDeletedFiles([...deletedFiles, acceptedFiles[index].name])
        let arr = _.cloneDeep(acceptedFiles);
        arr.splice(index, 1)
        setAcceptedFiles(arr);
    }
    const checkDisablePackgeInfo = (id) => {
        if (!_.isNil(id)) {
            const disablePackgeInfo = _.filter(
                props?.chargeReason[reward - 1]?.reasons, (item) => {
                    return item.id === id
                })
            return disablePackgeInfo[0];
        }
    }
    const showStatus = (value) => {
        if (!_.isNil(value)) {
            let type = _.filter(
                props.statusList.list, (item) => {
                    return item.value === value
                })
            return type[0].text
        }
    }
    const getEstimateValue = () => {
        props.handledataloading(true)
        dispatch(getEstimateAmount(packageInfo))
            .then((res) => {
                setEstimateFormula(res.calculation_formula)
                if (reward === 1)
                    setAmount('-' + res.total_value)
                else
                    setAmount(res.total_value)
            })
            .catch((err) => {
                dispatch(showAlertSnackbar({message: err.message, type: 'error'}))
            })
            .finally(() => {
                props.handledataloading(false)
            })
    }

    useEffect(() => {
        if (!_.isEmpty(props.payrollDetail) && props.payrollDialogType === 'review') {
            setDriverID(props.payrollDetail?.staff_id);
            setReward(props.payrollDetail?.trans_type);
            setReason(props.payrollDetail?.charge_reason);
            setAmount(props.payrollDetail?.amount);
            setDescription(props.payrollDetail?.comments);
            setAcceptedFiles(props?.payrollFileDetail);
            setPackageInfo(props?.payrollDetail?.tracking_nos);
        }
    }, [props.payrollDetail, props?.payrollFileDetail])
    useEffect(() => {
        if (props.payrollDialogType === 'review') {
            setDisableEdit(true);
        }
        if (props.payrollDialogType === 'new') {
            setDisableEdit(false);
        }
    }, [props.payrollDialogType]);
    useEffect(() => {
        if (props.open && props.payrollDialogType === 'new')
            clearAll();
    }, [props.open]);

    return (
        <Dialog
            open={props.open && !props.isDataloading}
            // onClose={() => {
            //     props.handleDialogClose()
            // }}
            maxWidth='sm'
            classes={{paper: classes.dialog}}
            fullWidth
        >
            <DialogCloseableTitle onClose={() => {
                props.handleDialogClose()
            }}>
                {t('payment_adjustment')}
            </DialogCloseableTitle>
            <Divider/>
            {
                props.payrollDialogType === 'review' &&
                <Paper>
                    <DialogContent>
                        <DialogContentText id="custom-dialog-description">
                            <Grid container spacing={2}>
                                <Grid
                                    container
                                    alignItems="center"
                                    justify="center"
                                    style={{marginLeft: '20px'}}
                                >
                                    <Grid item xs={6}>
                                        <Typography variant='body2'>
                                            <span className={classes.labelTitle}>{t('status')}: </span>
                                            {props?.payrollDetail && showStatus(props?.payrollDetail?.status) || "N/A"}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant='body2'>
                                            <span className={classes.labelTitle}>{t('entry_id')}: </span>
                                            {props?.payrollDetail && props?.payrollDetail?.id || "N/A"}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant='body2'>
                                            <span className={classes.labelTitle}>{t('created_on')}: </span>
                                            {props?.payrollDetail && showDate(props?.payrollDetail?.create_time) || "N/A"}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant='body2'>
                                            <span className={classes.labelTitle}>{t('created_by')}: </span>
                                            {props?.payrollDetail && props?.payrollDetail?.creator_name || "N/A"}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant='body2'>
                                            <span className={classes.labelTitle}>{t('last_edit')}: </span>
                                            {props?.payrollDetail && showDate(props?.payrollDetail?.last_update_time) || "N/A"}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant='body2'>
                                            <span className={classes.labelTitle}>{t('edit_by')}: </span>
                                            {props?.payrollDetail && props?.payrollDetail.last_update_name || "N/A"}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant='body2'>
                                            <span className={classes.labelTitle}>{t('approved_on')}: </span>
                                            {props?.payrollDetail && showDate(props?.payrollDetail?.review_time) || "N/A"}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Typography variant='body2'>
                                            <span className={classes.labelTitle}>{t('approved_by')}: </span>
                                            {props?.payrollDetail && props?.payrollDetail?.reviewer_name || "N/A"}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </DialogContentText>
                    </DialogContent>
                </Paper>
            }
            <Paper className={classes.dialog} style={{backgroundColor: '#292929'}}>
                <DialogContent>
                    <DialogContentText>
                        <Grid container spacing={2}>
                            <Grid
                                container
                                alignItems="center"
                                justify="center"
                                style={{marginLeft: '20px'}}
                            >
                                <Grid item xs={12} style={{marginTop: '10px'}}>
                                    <Typography variant='body2'>
                                        <span className={classes.labelTitle}>{t('driver_id')} </span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl variant="outlined" style={{width: '95%'}} size="small">
                                        <InputLabel
                                            shrink={true}
                                        >
                                        </InputLabel>
                                        <OutlinedInput
                                            value={driverID}
                                            id="paymentadjustmendialog_driverid_outlinedinput"
                                            disabled={disableEdit}
                                            onChange={(event) => {
                                                setDriverID(event.target.value)
                                            }}
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} style={{marginTop: '10px'}}>
                                    <Typography variant='body2'>
                                        <span className={classes.labelTitle}>{t('deduction_subsidy')} </span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl
                                        variant="outlined"
                                        size="small"
                                        style={{width: '95%', marginTop: '5px'}}
                                        disabled={disableEdit}
                                    >
                                        <Select
                                            value={reward}
                                            id="paymentadjustmendialog_reward_select"
                                            onChange={(event) => {
                                                setReward(event.target.value);
                                                setReason();
                                                if (event.target.value === 1) {
                                                    setAmount('-')
                                                } else {
                                                    setAmount('')
                                                }
                                            }}
                                        >
                                            {props?.chargeReason?.map((item) => {
                                                return <MenuItem key={item.id}
                                                                 value={item.id}>{item.label}</MenuItem>
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} style={{marginTop: '10px'}}>
                                    <Typography variant='body2'>
                                        <span className={classes.labelTitle}>{t('reason')} </span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl
                                        variant="outlined"
                                        size="small"
                                        style={{width: '95%', marginTop: '10px'}}
                                        disabled={disableEdit}
                                    >
                                        <Select
                                            value={reason}
                                            id="paymentadjustmendialog_reason_select"
                                            onChange={(event) => {
                                                setReason(event.target.value)
                                                // checkDisablePackgeInfo(event.target.value)
                                            }}
                                        >
                                            {!_.isNil(reward) && props?.chargeReason[reward - 1]?.reasons?.map((item) => {
                                                return <MenuItem key={item.id}
                                                                 value={item.id}>{item.name}</MenuItem>
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                {!_.isNil(reason) && checkDisablePackgeInfo(reason)?.need_order_list === 1 ? (
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} style={{marginTop: '10px'}}>
                                                <Typography variant='body2'>
                                                    <span className={classes.labelTitle}>{t('package_info')} </span>
                                                    <span style={{
                                                        fontSize: 11,
                                                        color: 'lightgray'
                                                    }}>{t('tracking_tnos_tip')} </span>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    disabled={disableEdit}
                                                    multiline
                                                    rows={5}
                                                    variant="outlined"
                                                    id="paymentadjustmendialog_packgeinfo_textfield"
                                                    style={{width: '95%'}}
                                                    value={packageInfo}
                                                    onChange={(event) => {
                                                        setPackageInfo(event.target.value)
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Button color='primary'
                                                        variant="text"
                                                        size="small"
                                                        disabled={_.isEmpty(packageInfo) || disableEdit}
                                                        id="paymentadjustmendialog_estimatevalue_button"
                                                        onClick={() => {
                                                            getEstimateValue()
                                                        }}>
                                                    {t('estimate')}
                                                </Button>
                                                {!_.isNil(estimateFormula) && estimateFormula}
                                            </Grid>
                                        </Grid>)
                                    :
                                    (null)
                                }
                                <Grid item xs={12} style={{marginTop: '10px'}}>
                                    <Typography variant='body2'>
                                        <span className={classes.labelTitle}>
                                            {!_.isNil(reason) && checkDisablePackgeInfo(reason)?.need_mileage === 1 ? (t('mileage'))
                                                : (t('amount'))}
                                        </span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl variant="outlined" style={{width: '95%'}}
                                                 disabled={disableEdit} size="small">
                                        <InputLabel
                                            shrink={true}>
                                        </InputLabel>
                                        <OutlinedInput
                                            value={amount}
                                            id="paymentadjustmendialog_amount_outlinedinput"
                                            onChange={(event) => {
                                                setAmount(event.target.value)
                                            }}
                                            startAdornment={
                                                !_.isNil(reason) && checkDisablePackgeInfo(reason)?.need_mileage === 1 ?
                                                    <InputAdornment position="start"></InputAdornment>
                                                    :
                                                    <InputAdornment position="start">$</InputAdornment>
                                            }
                                        />
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} style={{marginTop: '10px'}}>
                                    <Typography variant='body2'>
                                        <span className={classes.labelTitle}>{t('description')} </span>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        disabled={disableEdit}
                                        multiline
                                        rows={5}
                                        variant="outlined"
                                        id="paymentadjustmendialog_description_textfield"
                                        style={{width: '95%'}}
                                        value={description}
                                        onChange={(event) => {
                                            setDescription(event.target.value)
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} style={{marginTop: '10px', width: '95%'}}>
                                    <Typography variant='body2'>
                                        <span className={classes.labelTitle}>{t('attachment')} </span>
                                    </Typography>
                                    {
                                        _.isNil(acceptedFiles) ? (null) :
                                            (acceptedFiles?.map((file, index) => (
                                                    <Grid item xs={12}>
                                                        <Typography
                                                            // onClick={}
                                                            key={index}
                                                            variant="body3"
                                                            style={{color: 'orange', textDecoration: 'underline'}}>
                                                            <DescriptionIcon
                                                                style={{verticalAlign: 'middle'}}
                                                                onClick={() => {
                                                                    if (props?.payrollDialogType !== 'new') {
                                                                        downloadFile(file?.name)
                                                                    }
                                                                }
                                                                }/> {file?.name}
                                                        </Typography>
                                                        {!disableEdit &&
                                                            <IconButton
                                                                size="small"
                                                                aria-label="delete"
                                                                id="paymentadjustmendialog_deletefile_iconbutton"
                                                                onClick={() => {
                                                                    deleteFiles(index)
                                                                }
                                                                }>
                                                                <DeleteIcon/>
                                                            </IconButton>
                                                        }
                                                    </Grid>
                                                )
                                            ))
                                    }
                                </Grid>
                                {
                                    acceptedFiles?.length < MAX_FILE_COUNT && !disableEdit ? (
                                            <Grid item xs={12} style={{marginTop: '10px'}}>
                                                <Paper
                                                    {...getRootProps()}
                                                    background-color='#343434'
                                                    style={{
                                                        width: '95%', border: '1px dotted #ccc',
                                                        borderStyle: 'dotted',
                                                        backgroundColor: '#2e2e2e'
                                                    }}
                                                >
                                                    <Grid container spacing={2}>
                                                        <Grid item xs={2} style={{marginTop: '10px'}}>
                                                            <img src='/images/icons/image-regular.svg' style={{
                                                                width: '100px',
                                                                height: '80px'
                                                            }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={10} style={{marginTop: '20px'}}>
                                                            <Typography style={{marginLeft: '50px', fontSize: 16}}
                                                                        variant="body1">
                                                                {
                                                                    isDragActive
                                                                        ? 'Drop the files here '
                                                                        : 'Drop your image here, or '
                                                                }
                                                                <span style={{color: 'orange'}}>{'browse'}</span>
                                                            </Typography>
                                                            <Typography
                                                                style={{marginLeft: '50px', fontSize: 13, color: 'grey'}}
                                                                variant="body1"
                                                            >
                                                                {'File format includes JPEG, PNG, PDF, XLSX and MP4'}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <input {...getInputProps()} />
                                                </Paper>
                                                <Typography style={{
                                                    paddingLeft: '5px',
                                                    paddingTop: '5px',
                                                    fontSize: '13px',
                                                    color: 'grey',
                                                    paddingBottom: '5px'
                                                }} variant="body1">
                                                    {t('upload_tip')}
                                                </Typography>
                                            </Grid>)
                                        :
                                        (null)
                                }
                                {
                                    props?.payrollDetail?.status !== APPROVED_STATUS &&
                                    <Grid item xs={12} style={{marginTop: '30px'}}>
                                        <div style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            width: '95%'
                                        }}>
                                            {
                                                !disableEdit &&
                                                <Button
                                                    variant="outlined"
                                                    color='primary'
                                                    id="paymentadjustmendialog_cancel_button"
                                                    onClick={() => {
                                                        props.handleDialogClose();
                                                        if (props.payrollDialogType === 'review') {
                                                            setDisableEdit(true)
                                                        }
                                                    }}>
                                                    {t('cancel')}
                                                </Button>
                                            }
                                            {
                                                disableEdit && props.payrollDialogType === 'review' &&
                                                <Button
                                                    variant="outlined"
                                                    color='secondary'
                                                    id="paymentadjustmendialog_delete_button"
                                                    onClick={() => {
                                                        props.handleDeleteEntity(props?.payrollDetail?.id)
                                                    }}>
                                                    {t('delete')}
                                                </Button>
                                            }
                                            {
                                                !disableEdit &&
                                                <div>
                                                    {
                                                        props.ableManagerAccess === false &&
                                                        <Button style={{marginRight: '10px'}}
                                                                color='primary'
                                                                variant="contained"
                                                                id="paymentadjustmendialog_save_button"
                                                                onClick={() => {
                                                                    setOpenDetailsDialog(false)
                                                                    savePayRollTicket(1, props.payrollDialogType)

                                                                }}
                                                                disabled={false}>
                                                            {t('save')}
                                                        </Button>
                                                    }
                                                    {
                                                        props.payrollDialogType === 'new' &&
                                                        <Button color='primary'
                                                                variant="contained"
                                                                id="paymentadjustmendialog_submitreview_button"
                                                                onClick={() => {
                                                                    setOpenDetailsDialog(false)
                                                                    savePayRollTicket(2, props.payrollDialogType)
                                                                }}
                                                                disabled={false}>
                                                            {t('submit_review')}
                                                        </Button>
                                                    }
                                                </div>
                                            }
                                            {
                                                disableEdit && props.payrollDialogType === 'review' && props.ableManagerAccess === true && props.payrollDetail.status === SUBMITED_TO_REVIEW &&
                                                <div>
                                                    <Button style={{marginRight: '10px'}}
                                                            color='primary'
                                                            variant="contained"
                                                            id="paymentadjustmendialog_approve_button"
                                                            onClick={() => {
                                                                setOpenDetailsDialog(false)
                                                                props.handleMangerApprove(props?.payrollDetail?.id)

                                                            }}
                                                            disabled={false}>
                                                        {t('approve')}
                                                    </Button>
                                                </div>
                                            }
                                            {
                                                disableEdit === true && props.payrollDialogType === 'review' && props.ableManagerAccess === false &&
                                                <Button style={{marginRight: '10px'}}
                                                        color='primary'
                                                        variant="contained"
                                                        id="paymentadjustmendialog_edit_button"
                                                        onClick={() => {
                                                            setDisableEdit(false)
                                                        }}>
                                                    {t('edit')}
                                                </Button>
                                            }
                                        </div>
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
            </Paper>
        </Dialog>
    )
}

export default PaymentAdjustmentDialog;